// extracted by mini-css-extract-plugin
export default {"wrapper":"nr-z","response":"or-z","error":"pr-z","disabled":"qr-z","buttons":"rr-z","feedbackQuestionSection":"sr-z","yesNoWrapper":"tr-z"};